import './App.css';
import Hero from './components/hero/hero';
import Projects from './components/projects/projects';
import Technologies from './components/tech/tech';
import About from './components/about/about';
import Contact from './components/contact/contact';
import Socials from './components/socials/socials';
import './components/header/header.css';
import { useRef } from 'react';

function App() {

    const homeRef = useRef(null)
    const projectRef = useRef(null)
    const techRef = useRef(null)
    const aboutRef = useRef(null)
    const contactRef = useRef(null)
    const homeScroll = () => homeRef.current.scrollIntoView();
    const projectScroll = () => projectRef.current.scrollIntoView();
    const techScroll = () => techRef.current.scrollIntoView();
    const aboutScroll = () => aboutRef.current.scrollIntoView();
    const contactScroll = () => contactRef.current.scrollIntoView();

    return (
        <div className="App">

            <div className="navbar">
                <div className="navbar-left navlink" onClick={homeScroll}>Pulkit's Portfolio</div>
                <div className="navbar-center">
                    <div className="navlink" onClick={homeScroll}>Home</div>
                    <div className="navlink" onClick={projectScroll}>Projects</div>
                    <div className="navlink" onClick={techScroll}>Technologies</div>
                    <div className="navlink" onClick={aboutScroll}>About</div>
                    <div className="navlink" onClick={contactScroll}>Contact</div>
                </div>
                <div className="navbar-right"><Socials /></div>
            </div>

            <div ref={homeRef} className='hero'>
                <Hero />
            </div>

            <div ref={projectRef} className='hero'>
                <Projects />
            </div>

            <div ref={techRef} className='hero'>
                <Technologies />
            </div>

            <div ref={aboutRef} className='hero' style={{flexDirection:'column', justifyContent:'space-between'}}>
                <About />
                <div ref={contactRef}>
                    <Contact />
                </div>
            </div>
        </div>
    );
}

export default App;
